import { Adapter as t, getAdapter as p } from "../../../../../../adapter.js";
import { TierCycleModel as l } from "./tierCycle.model.js";
import { TierCycleRuleAdapter as a } from "./tierCycleRule/tierCycleRule.adapter.js";
class s extends t {
  adapt(e) {
    const r = p(a);
    return new l({
      repeat: e.repeat,
      rules: e.rules ? e.rules.map(r.adapt) : []
    });
  }
  serialize(e) {
  }
}
export {
  s as TierCycleAdapter
};
//# sourceMappingURL=tierCycle.adapter.js.map
